import { useTranslator } from '@bluebeam/react-i18n';
import Pending from 'components/Icons/Pending';
import React from 'react';

const ExportConfirmationStep: React.FC = () => {
  const { translate } = useTranslator(['requestDownloadModal']);
  return (
    <>
      <div className="column px5 pt9 pb1">
        <div className="column justify-center align-self-center">
          <Pending width="200px" height="200px" />
        </div>
      </div>
      <div className="pt1">
        <div className="row justify-center color-black-2 font-size-7 semi-bold">
          <p>
            {translate(
              'requestDownloadModal:exportModal.exportConfirmationStep.title'
            )}
          </p>
        </div>
        <p className="color-black-1 font-size-5 pb1 normal pl5 pr5">
          {translate(
            'requestDownloadModal:exportModal.exportConfirmationStep.content'
          )}
        </p>
      </div>
    </>
  );
};

export default ExportConfirmationStep;
